import { Tag, Flex } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { selectActiveFilters, setFilter } from '../../../../store/products/slice';
import { useSearchProductsInfiniteQuery } from '../../../../store/products/productsApi';

const ActiveFiltersBar = () => {
  const dispatch = useAppDispatch();
  const activeFilters = useAppSelector(selectActiveFilters);

  const { data } = useSearchProductsInfiniteQuery({
    filters: activeFilters,
  });

  const facets = data?.pages[data.pages.length - 1]?.facets || [];

  const handleRemoveFilter = (field: string, value: string) => {
    const filter = activeFilters.find(f => f.field === field);
    if (!filter) return;
    const values = filter.value.split(',').filter(v => v !== value);
    dispatch(setFilter({ field, values }));
  };

  if (!activeFilters.length) return null;

  const productTypeFacetsMap = facets
    .find(f => f.key.key === 'productTypeId')
    ?.values.reduce((prev, curr) => {
      return {
        ...prev,
        [curr.id]: curr.value,
      };
    }, {});

  return (
    <div style={{ padding: '24px 0' }}>
      <Flex gap={8} wrap>
        {activeFilters.map(filter =>
          filter.value.split(',').map(val => {
            let displayValue = val;

            if (filter.field === 'productTypeId' && productTypeFacetsMap) {
              displayValue = productTypeFacetsMap?.[val as keyof typeof productTypeFacetsMap];
            }

            return (
              <Tag
                key={`${filter.field}-${val}`}
                closable
                onClose={() => handleRemoveFilter(filter.field, val)}
                style={{
                  background: '#ffffff',
                  border: '1px solid #E9ECEF',
                  color: '#171717',
                  borderRadius: 20,
                  padding: '8px 12px',
                  margin: 0,
                }}
              >
                {displayValue}
              </Tag>
            );
          }),
        )}
      </Flex>
    </div>
  );
};

export default ActiveFiltersBar;
